var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    y: 0.5,
    fill: "#64BE3C",
    rx: 7.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.246 4.017a.263.263 0 0 0-.263-.263h-.082c-1.416 0-2.997.741-4.02 1.863a3.9 3.9 0 0 0-2.664 1.15.272.272 0 0 0 .153.462l.945.138a.267.267 0 0 0 .016.364l1.942 1.942a.27.27 0 0 0 .192.079.27.27 0 0 0 .176-.067l.138.945c.015.098.086.18.188.212a.3.3 0 0 0 .082.012c.075 0 .15-.032.204-.083A3.89 3.89 0 0 0 9.395 8.12c1.15-1.048 1.898-2.672 1.863-4.103zM8.771 8.673a3.4 3.4 0 0 1-.55 1.286l-.101-.702.651-.58zm.137-.851-1.44 1.282-1.58-1.58.137-.157 1.15-1.287c.882-1.02 2.259-1.718 3.526-1.785-.063 1.267-.765 2.648-1.793 3.527m-3.161-.946-.706-.102a3.3 3.3 0 0 1 1.286-.549z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.662 5.339a.81.81 0 0 0-1.146 0 .812.812 0 1 0 1.146 0m-.385.765a.275.275 0 0 1-.38 0 .268.268 0 0 1 .192-.46c.074 0 .141.028.192.08a.27.27 0 0 1 0 .38zM5.287 8.704c-.274 0-.533.106-.717.286-.326.33-.73 1.648-.808 1.91-.028.095 0 .2.066.271a.27.27 0 0 0 .192.079c.028 0 .051 0 .079-.012.263-.078 1.585-.486 1.906-.808.192-.192.298-.447.298-.718s-.106-.525-.298-.718a1 1 0 0 0-.718-.286zm.334 1.342c-.106.106-.557.302-1.18.514.211-.628.407-1.075.513-1.181a.47.47 0 0 1 .333-.137c.126 0 .244.047.334.137a.476.476 0 0 1 0 .67z"
  }))));
};
export default SvgRocket;